<script setup lang="ts">
type KeyFact = { label: string; value: string; icon: string };

defineProps<{
  facts: KeyFact[];
}>();
</script>

<template>
  <section
    v-if="facts.length"
    class="trek-key-facts map-page-key-facts"
    aria-labelledby="map-page-key-facts-heading"
  >
    <h2 id="map-page-key-facts-heading">Key facts</h2>
    <dl class="trek-key-facts__list">
      <div
        v-for="fact in facts"
        :key="fact.label"
        class="trek-key-facts__item"
      >
        <div class="trek-key-facts__icon" aria-hidden="true">
          <AppSVGBrandIconsAll :icon-name="fact.icon" />
        </div>
        <div class="trek-key-facts__text">
          <dt>{{ fact.label }}</dt>
          <dd>{{ fact.value }}</dd>
        </div>
      </div>
    </dl>
  </section>
</template>
